import { DefinitionsStyle } from "./definitionsStyle.model";
import { DistributionDetailsRequest } from "./questionnaire.model";
import { QuestionnaireCategory } from "./questionnaireCategory.model";
import { EReplyStatus, Recipients } from "./recipients.model";
import { User } from "./user.model";

export interface QuestionnaireRow {
    readonly id: number;
    readonly name: string;
    readonly distributionDate?: Date;
    readonly submissionDateNTZ?: Date;
    readonly creator: User;
    readonly category?: QuestionnaireCategory;
    readonly recipients: Recipients;
    readonly templateName?: string;
    readonly status: EQuestionnaireStatus
    readonly definitions: DefinitionsStyle;
    readonly sourceId: number | null;
    readonly guidToUser?: string;
    readonly recipientId?: number;
    readonly statusToUser?: EReplyStatus;
    readonly templateImage?: string;
    readonly distributionDetails?: DistributionDetailsRequest;
    readonly isUnauthorized?: boolean;
    readonly mainAnswer?: string;
    readonly requiredAmount?: number;
    readonly approvedAmount?: number;
    readonly comment?: string;
}
export enum EQuestionnaireStatus {
    Edit = 1, Distributed, Respond
}
